module.exports = __webpack_public_path__ + "static/media/(V)_MG_6092_-_capim_dourado_-_bijuterias.75bd39a4.jpg";